import styled from 'styled-components';
import breakpoints from 'bdata-sns-shared/mini/utils/miniBreakpoints';
import COLORS from '@mlb/react-patterns/style/universal.color';

const { mobile } = breakpoints;
const {
    mlbGrey2,
    mlbGrey5
} = COLORS;

export const SeriesStatusMessageWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 0px 6px 8px;
    font-size: 11px;

    color:${mlbGrey5};
    

    @media (max-width: ${mobile}) {
        display: none;
    }
`;

export const MessageWrapper = styled.div`
    display: inline-block;
    flex: 2;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const PipeWrapper = styled.span`
    color: ${mlbGrey2};
    margin: 0 4px;
`;

export const BroadcastsWrapper = styled.div`
    flex: 1;
    padding-right: 8px;
    box-sizing: border-box;
    text-align: center;
    max-width: 50px;

    img {
        height: auto;
        max-height: 14px;
        vertical-align: middle;
    }    
`;
